import { useEffect, useRef, useState } from 'react'
import { connected, withErrorBoundary, Spinner, NoResults, Formatter, GradientedScroller } from 'shared'
import { EventApi, Park, ParkApi, User, HighlightApi } from 'api'
import { MissingImage } from 'customizations'
import { TopLevelPage } from 'ui'
import EventCard from './EventCardHomeFeed'
import ParkCard from '../parks/ParkCard'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HomeFeed = ({ match }) => {
  const [highlights, setHighlights] = useState([]);
  const [lifestyleEvents, setLifestyleEvents] = useState([]);
  const [lifestylePlaces, setLifestylePlaces] = useState([]);
  const [lifestyleSelected, setLifestyleSelected] = useState();
  const [lifestyles, setLifestyles] = useState([]);
  const [secondaryHighlights, setSecondaryHighlights] = useState([]);

  const isMobile = window.innerWidth < 576;
  const eventsSliderRef = useRef(null);
  const placesSliderRef = useRef(null);
  const feedItemId = match.params.id;
  const groups = EventApi.kick('mineGrouped');

  useEffect(() => {
    HighlightApi.primaryHighlights()
      .then(setHighlights)
      .catch((error) => console.error("Failed to fetch primary highlights:", error));

    HighlightApi.primaryLifestyles()
      .then((fetched) => {
        setLifestyles(fetched);
        if (fetched[0]) lifestyleClicked(fetched[0]);
        console.log("Lifestyles", fetched);
      })
      .catch((error) => console.error("Failed to fetch primary highlights:", error));

    HighlightApi.secondaryHighlights()
      .then(setSecondaryHighlights)
      .catch((error) => console.error("Failed to fetch secondary highlights:", error));
  }, []);

  const lifestyleClicked = (lifestyle) => {
    const tagIds = lifestyle.place_id.filter((id) => !_.isEmpty(id));
    setLifestyleSelected(lifestyle);
    EventApi.all({ tag_ids: tagIds }).then((data) => {
      setLifestyleEvents(data);
      eventsSliderRef.current?.slickGoTo(0);
    });
    ParkApi.index({ tag_ids: tagIds }).then((data) => {
      const shuffled = data.sort(() => Math.random() - 0.5);
      setLifestylePlaces(shuffled);
      placesSliderRef.current?.slickGoTo(0);
    });
  };

  const renderHeroImageSection = () => (
    <div className="px-3 mb-5">
      <div className='SectionHero position-relative' data-nc-id="SectionHero">
        <div className="headingSection position-absolute text-center d-flex flex-column align-items-center w-100">
          <span className="homeFeedSubText font-weight-bold d-block" style={{ color: User.homeFeedSubTextColour || 'inherit' }}>
            <span dangerouslySetInnerHTML={{ __html: Formatter.simpleFormat(User.homeFeedSubText) }} />
          </span>
          <h1 className="homeFeedHeader font-weight-bold" style={{ color: User.homeFeedHeaderColour || 'inherit' }}>
            {
              User.homeFeedHeader && User.homeFeedHeader.trim() != '' ? User.homeFeedHeader : <span className="visually-hidden">Home Feed</span>
            }
          </h1>
        </div>
        <div className="position-relative homeFeedBanner">
          {User.homeFeedBanner ? (
            User.homeFeedBanner.endsWith('.mp4') || User.homeFeedBanner.endsWith('.webm') ? (
              <video className="position-absolute w-100 h-80 object-fit-cover homeFeedPicture" src={User.homeFeedBanner} autoPlay loop muted controls={false} />
            ) : (
              <img className="position-absolute w-100 h-80 object-fit-cover homeFeedPicture" src={User.homeFeedBanner} alt="hero" />
            )
          ) : (
            <div className="position-absolute w-100 h-80 object-fit-cover"></div>
          )}
        </div>
      </div>
    </div>
  );

  const renderHighlights = () => highlights?.length ? (
    <div className="row mb-md-5 pb-md-5">
      <div key={0} className="col-12 col-md-4 col-sm-6 col-lg-4 d-flex mb-3">
        <CardCategory {...highlights[0]} />
      </div>
      <div key={1} className="col-12 col-sm-6 col-md-4 col-lg-4">
        <div className="row">
          <div className="col-12 mb-3"><CardCategory {...highlights[1]} /></div>
          <div className="col-12 mb-3"><CardCategory {...highlights[2]} /></div>
        </div>
      </div>
      <div key={2} className="col-12 col-sm-6 col-md-4 col-lg-4 d-flex mb-3">
        <CardCategory {...highlights[3]} />
      </div>
    </div>
  ) : null;

  const renderHighlightsSecondary = () => secondaryHighlights.length ? (
    <div className="nc-SectionGridCategoryBox position-relative">
      <div className='nc-Section-Heading position-relative d-flex flex-column text-center align-items-center mb-md-5'>
        <div className='w-100 max-w-50 mx-auto'>
          <h2 className="h2 font-weight-bold custom-heading-community">Discover Community Happenings and Amenities</h2>
        </div>
      </div>
      <div className="row">
        {secondaryHighlights.map((park, i) => (
          <div className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-4 secondary-highlight-container" key={i}>{renderSecondaryHighlight(park)}</div>
        ))}
      </div>
    </div>
  ) : null;

  const renderSecondaryHighlight = (park) => (
    <Link to={`home/${park.uid}`} className="nc-CardCategoryBox1 d-flex align-items-center p-3 rounded shadow-sm rounded" data-nc-id="CardCategoryBox1">
      <div className="flex-shrink-0 rounded-circle overflow-hidden" style={{ width: '96px', height: '96px' }}>
        <img
          src={park.image_preview_url || MissingImage}
          className="img-fluid"
          style={{ height: '96px' }}
          alt={ park?.name ? `${park.name} preview image` : "Park preview image" }
        />
      </div>
      <div className="ml-3 flex-grow-1">
        <h2 className="h5 font-weight-medium mb-1 text-truncate fontColour custom-text-community">{park.name}</h2>
      </div>
    </Link>
  );

  const renderLifestyleEvents = () => (
    <div className="row">
      <div className="upcoming-events-container lifestyle-events col-12 mt-0">
        <h4 className="mb-3 text-muted custom-text-community">Explore Matching Events</h4>
        <Slider ref={eventsSliderRef} {...sharedSliderProps()}>
          {lifestyleEvents.map((event) => (
            <div className="pr-2 feed-column-body mb-3" key={event.uid}><EventCard event={event} base='home' /></div>
          ))}
        </Slider>
      </div>
    </div>
  );

  const renderLifestylePlaces = () => (
    <div className="row">
      <div className="CustomMenu lifestyle-parks col-12 mt-5">
        <h4 className="mb-3 text-muted custom-text-community">Explore Matching Amenities</h4>
        <Slider ref={placesSliderRef} {...sharedSliderProps()}>
          {lifestylePlaces.map((place) => (
            <div className="pr-2 mb-3" key={place.uid}><ParkCard park={place} base='home' /></div>
          ))}
        </Slider>
      </div>
    </div>
  );

  const renderLifestyleExplorer = () => (
    lifestyles?.length && User.current?.isGuestExperience ? (
      <div className="lifestyle-explorer">
        <div className="row justify-content-center parks-header-container">
          <div className="col-md-12">
            <h1 className="upcoming-events-header font-weight-bold custom-heading-community">Lifestyle Explorer</h1>
            <div className="row mb-5 lifestyles">
              {lifestyles.map((lifestyle) => (
                <div className="lifestyle-card col-12 col-md-3" onClick={() => lifestyleClicked(lifestyle)} key={lifestyle.name}>
                  <div className={`nc-CardCategoryBox1 d-flex align-items-center p-3 rounded shadow-sm rounded ${lifestyle.name === lifestyleSelected?.name ? 'active' : ''}`}>
                    <div className="flex-shrink-0 rounded-circle overflow-hidden" style={{ width: '96px', height: '96px' }}>
                      <img
                        src={lifestyle.image || MissingImage}
                        className="img-fluid"
                        style={{ height: '96px' }}
                        alt={ lifestyle?.id ? `${lifestyle.name} (ID: ${lifestyle.id})` : `${lifestyle.name}` }
                      />
                    </div>
                    <div className="ml-3 flex-grow-1">
                      <h2 className="h5 font-weight-medium mb-1 text-truncate fontColour custom-text-community">{lifestyle.name}</h2>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {renderLifestyleEvents()}
            {renderLifestylePlaces()}
          </div>
        </div>
      </div>
    ) : null
  );

  const renderUpcomingEvents = () => {
    if (User.current && !User.current.isGuestExperience) {
      if (_.isEmpty(groups)) {
        return <NoResults className='compact'><NoResultsMessage /></NoResults>;
      } else {
        return (
          <div className="upcoming-events-container">
            <div className="row justify-content-center parks-header-container">
              <div className="col-md-8">
                <h1 className="upcoming-events-header custom-heading-community">Upcoming Events For You</h1>
              </div>
            </div>
            <GradientedScroller containerClassName="feed-columns row">
              {Object.keys(groups).sort().map((date) => (
                <section className="feed-column col-sm-4 col-lg-4 col-xl-3" key={date}>
                  <header className="feed-column-header custom-text-community">
                    <b>{Formatter.dateToWeekDay(date, { format: 'full' })}</b>
                    <time dateTime={date}>{Formatter.date(date, 'usDateYYYY')}</time>
                    <div className="feed-column-border">
                      <span className="feed-column-circle"></span>
                      <span className="feed-column-line"></span>
                    </div>
                  </header>
                  <div className="feed-column-body">
                    {groups[date].map((model) => (
                      model instanceof Park ? (
                        <ParkCard park={model} key={model.uid} base='home' />
                      ) : (
                        <EventCard event={model} key={model.uid} base='home' />
                      )
                    ))}
                  </div>
                </section>
              ))}
            </GradientedScroller>
          </div>
        );
      }
    }
    return null;
  };

  const sharedSliderProps = () => ({
    dots: true,
    infinite: false,
    slidesToShow: isMobile ? 1 : 4,
    slidesToScroll: isMobile ? 1 : 4,
    arrows: false,
  });

  if (!groups) return <Spinner />;

  return (
    <TopLevelPage className="HomeFeed" fullWidth={true} modelId={feedItemId} base="/home">
      <div className="HomeFeedInner">
        <div>{renderHeroImageSection()}</div>
        <div className="container-fluid">
          {renderHighlightsSecondary()}
          {renderHighlights()}
          {renderUpcomingEvents()}
          {renderLifestyleExplorer()}
        </div>
      </div>
    </TopLevelPage>
  );
};

const NoResultsMessage = () => {
  const appName = application.assets.get('app_name');
  const text = User.guest ? App.guestPassSettings.welcome_text : `Curating the ${appName} experience just for you.\nThe more you use the app, the more the app learns about you.\nYour personalized ${appName} feed will start appearing here shortly.`;
  return <p dangerouslySetInnerHTML={{ __html: Formatter.simpleFormat(text) }} />;
};

const CardCategory = ({ name, image, place }) => (
  <Link to={`home/${place?.uid}`} className='nc-CardCategory position-relative d-flex w-100 group overflow-hidden' data-nc-id="CardCategory">
    <div className="embed-responsive embed-responsive-16by9 w-100"></div>
    <img
      src={image || MissingImage}
      alt={name ? `${name} image` : "Background image"}
      className="img-fluid position-absolute w-100 h-100"
    />
    <div className="position-absolute fixed-bottom p-3 p-sm-4 text-white">
      <span className="position-absolute w-100 h-100 bg-dark-gradient"></span>
      <h2 className="position-relative text-lg font-weight-bolder highlights-information" style={{ color: User.homeFeedHighLightColour || 'inherit' }}>{name}</h2>
    </div>
  </Link>
);

export default withErrorBoundary(connected(HomeFeed));
